export const categories = [
  {
    id: "pingtai-jieshao",
    name: "平台介绍",
    description: "全面了解金宝博平台，包括平台特色、安全保障与技术优势",
    icon: "ri-building-2-line",
    articleCount: 12,
  },
  {
    id: "youhui-huodong",
    name: "优惠活动",
    description: "最新优惠促销信息、限时活动与会员专属福利",
    icon: "ri-gift-line",
    articleCount: 18,
  },
  {
    id: "shiyong-zhinan",
    name: "使用指南",
    description: "注册、登录、充值、操作全流程详细指导",
    icon: "ri-guide-line",
    articleCount: 15,
  },
  {
    id: "huiyuan-fuwu",
    name: "会员服务",
    description: "会员等级体系、专属权益与VIP服务介绍",
    icon: "ri-vip-crown-line",
    articleCount: 9,
  },
  {
    id: "anquan-zixun",
    name: "安全资讯",
    description: "平台安全动态、资金保障与数据保护政策",
    icon: "ri-shield-check-line",
    articleCount: 7,
  },
  {
    id: "changjian-wenti",
    name: "常见问题",
    description: "用户常见疑问解答与客服帮助指南",
    icon: "ri-question-answer-line",
    articleCount: 14,
  },
];

export type Category = (typeof categories)[0];